import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Batch } from '@app/shared/models/batch.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-batches-form',
  templateUrl: './select-batches-form.component.html',
  styleUrls: ['./select-batches-form.component.scss']
})
export class SelectBatchesFormComponent implements OnInit {
  @Input() showValidations = false;
  @Input() availableBatches: Batch[] = [];
  @Input() selectedBatches: Batch[] = [];

  form: UntypedFormGroup;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new UntypedFormGroup({
      selectedBatches: new UntypedFormControl(this.selectedBatches, [Validators.required]),
    });
  }

  setBatches(availableBatches: Batch[], selectedBatches: Batch[]) {
    this.availableBatches = availableBatches;
    this.selectedBatches = selectedBatches;
  }

  loadFormValues(selectedBatches: Batch[]) {
    this.form.setValue({
      selectedBatches: selectedBatches
    })
  }


  resetForm() {
    this.showValidations = false;

    this.availableBatches = [];
    this.selectedBatches = [];

    this.loadFormValues(this.selectedBatches);
  }

  get getFormValue() {
    return this.form.value;
  }

  get isFormValid() {
    this.showValidations = true;
    return this.form.valid;
  }

   get sourceHeader() {
    return this.translate.instant('admin.lifts.copyBatchesModal.availableBatches');
  }

   get targetHeader() {
    return this.translate.instant('admin.lifts.copyBatchesModal.selectedBatches');
  }
}
